import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import TrustedImg from "../../images/location_new/fold11/Ohio.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "gatsby";

function Trustedcompany(props) {
  return (
    <div className="trusted_company p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Expand Your Businesses With Our Mobile App Development Company In
              Ohio
            </h2>
            <p>
              TekRevol is a revolutionary company in the tech industry. With
              tech-integrated solutions and a client-focused approach, we’ve
              come so far and achieved a reputable presence in the global market
              in the span of 5 years.
            </p>
            <p>
              Our services facilitate businesses of different scales from
              startups to vast organizations for the digitalization of their
              operations. Meanwhile, our highly qualified and skillful team of
              mobile app developers in Ohio has all the potential that is
              required to provide the best possible solution.
            </p>
            <p>
              So, connect with us to have a valuable chat about the
              digitalization of your business that might become the core reason
              to upscale your business.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Let's Connect!
            </Link>
          </Col>
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="trustedimg">
              <LazyLoadImage
                src={TrustedImg}
                effect="blur"
                alt="TrustedImg"
                className="img-fluid"
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Trustedcompany;
